export default __webpack_public_path__ + "static/media/pauseButton.7321b5f2.png";